
cmsForm2022.prototype.checkboxToggles = function(){
  var checkboxToggles = document.querySelectorAll("input[data-checkbox-toggle]");
  for(let i=0;i<checkboxToggles.length;i++){

    var c = checkboxToggles[i];
    var toggleReverse = c.getAttribute("data-checkbox-toggle-reverse");

    if(c.checked){
      document.getElementById(c.getAttribute("data-checkbox-toggle")).style.display = toggleReverse ? "none" : "block";
    }
    else{
      document.getElementById(c.getAttribute("data-checkbox-toggle")).style.display = toggleReverse ? "block" : "none";
    }

    c.addEventListener("click",function(e){
      if(e.currentTarget.checked){
        document.getElementById(e.currentTarget.getAttribute("data-checkbox-toggle")).style.display = toggleReverse ? "none" : "block";
      }
      else{
        document.getElementById(e.currentTarget.getAttribute("data-checkbox-toggle")).style.display = toggleReverse ? "block" : "none";
      }
    });
  }
};
